import Alpine from "alpinejs";
import { OrganisationService } from "@src/js/services/organisationService";
Alpine.data("organisations", () => ({
    data: [],
    page: 1,
    pageSize: 10,
    async load() {
        try {
            this.data = await OrganisationService.getAll();
        }
        catch (err) {
            alert(err.message);
        }
    },
    get paginatedData() {
        const start = (this.page - 1) * this.pageSize;
        return this.data.slice(start, start + this.pageSize);
    },
    get pageCount() {
        return Math.ceil(this.data.length / this.pageSize);
    }
}));
